import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send, MessageCircle, Fish } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axiosInstance from '../api/axiosInstance';
import './ContactPage.css';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setSending(true);
  try {
    const res = await axiosInstance.post('/contact', form);
    if (res.data.success) {
      setSent(true);
    } else {
      alert(res.data.message || 'Failed to send message');
    }
  } catch (e) {
    alert('Failed to send message. Please try again.');
  } finally {
    setSending(false);
  }
};
  return (
    <>
      <Navbar />
      <div className="contact-page">

        {/* Hero */}
        <section className="contact-hero">
          <div className="container">
            <div className="contact-hero-badge">
              <MessageCircle size={14} />
              Get In Touch
            </div>
            <h1 className="contact-hero-title">We'd Love to <span>Hear From You</span></h1>
            <p className="contact-hero-sub">Have a question, need help with an order, or just want to say hi? Our team is ready to help.</p>
          </div>
        </section>

        {/* Info Cards */}
        <section className="contact-info-section">
          <div className="container">
            <div className="contact-info-grid">
              <div className="contact-info-card">
                <div className="contact-info-icon"><MapPin size={22} /></div>
                <h3>Visit Us</h3>
                <p>Unnumbered House, Behind Kingdom Bookshop<br />Ako Adjei Road, OSU, Kinbu Street<br />Accra, Ghana</p>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon"><Phone size={22} /></div>
                <h3>Call Us</h3>
                <p><a href="tel:0550866710">0550866710</a></p>
                <p><a href="tel:0505078077">0505078077</a></p>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon"><Mail size={22} /></div>
                <h3>Email Us</h3>
                <p><a href="mailto:sales@auroragh.com">sales@auroragh.com</a></p>
                <p><a href="mailto:orders@auroragh.com">orders@auroragh.com</a></p>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon"><Clock size={22} /></div>
                <h3>Working Hours</h3>
                <p>Monday – Friday<br />09:00 – 17:00 GMT</p>
                <p>Saturday<br />10:00 – 14:00 GMT</p>
              </div>
            </div>
          </div>
        </section>

        {/* Form */}
        <section className="contact-form-section">
          <div className="container">
            <div className="contact-form-wrapper">
              <div className="contact-form-left">
                <h2>Send Us a Message</h2>
                <p>Fill out the form and our team will get back to you within 24 hours.</p>
                <div className="contact-form-fish">
                  <Fish size={120} color="rgba(41,171,226,0.08)" strokeWidth={1} />
                </div>
              </div>
              <div className="contact-form-right">
                {sent ? (
                  <div className="contact-success">
                    <div className="contact-success-icon"><Mail size={32} color="#29ABE2" /></div>
                    <h3>Message Sent!</h3>
                    <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                    <button className="contact-btn" onClick={() => setSent(false)}>Send Another</button>
                  </div>
                ) : (
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="contact-form-row">
                      <div className="contact-field">
                        <label>Full Name *</label>
                        <input required type="text" placeholder="John Doe" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                      </div>
                      <div className="contact-field">
                        <label>Email Address *</label>
                        <input required type="email" placeholder="john@email.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
                      </div>
                    </div>
                    <div className="contact-form-row">
                      <div className="contact-field">
                        <label>Phone Number</label>
                        <input type="tel" placeholder="0550000000" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
                      </div>
                      <div className="contact-field">
                        <label>Subject *</label>
                        <select required value={form.subject} onChange={e => setForm({...form, subject: e.target.value})}>
                          <option value="">Select a subject</option>
                          <option value="order">Order Inquiry</option>
                          <option value="delivery">Delivery Issue</option>
                          <option value="product">Product Question</option>
                          <option value="loyalty">Loyalty Program</option>
                          <option value="complaint">Complaint</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="contact-field">
                      <label>Message *</label>
                      <textarea required rows={5} placeholder="How can we help you?" value={form.message} onChange={e => setForm({...form, message: e.target.value})} />
                    </div>
                    <button type="submit" className="contact-btn" disabled={sending}>
                      {sending ? 'Sending...' : <><Send size={16} /> Send Message</>}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default ContactPage;